// This hash manages restrictions on some tiles. Feel free to add to this if a specific tile requires specific elements to be disabled. Ideally these will be powered by the backend in the future.
// Keyed by DragonTile.slug, not .name — name is a display string the backend
// renames freely (Price Drop -> Sale), slug is the stable per-site identity.
export const parentTileDisabledHash: Record<
  string,
  {
    disableConfig?: boolean; // Disables the configuration UI in the drawer
  }
> = {
  ["magic"]: {
    disableConfig: true,
  },
  ["discover"]: {
    disableConfig: true,
  },
  ["cart"]: {
    disableConfig: true,
  },
  ["browse"]: {
    disableConfig: true,
  },
  ["new-arrivals"]: {
    disableConfig: true,
  },

  // These tiles are disabled because nothing is set in backend
  // if we want to re-enable these, we need to backend logic to support it
  ["back-in-stock"]: {
    disableConfig: true,
  },
  ["price-drop"]: {
    disableConfig: true,
  },
  ["low-stock"]: {
    disableConfig: true,
  },
  ["rebuy"]: {
    disableConfig: true,
  },
  ["subscribe"]: {
    disableConfig: true,
  },
  ["post-purchase"]: {
    disableConfig: true,
  },
  ["product-story"]: {
    disableConfig: true,
  },
};
